export function trackGoogleAnalyticsEvent(title: string): void {
    if ((window as any).GATrackEvent) {
      (window as any).GATrackEvent(title);
    }
  }
